import { Instance, SnapshotIn, types } from "mobx-state-tree";

import { LengthUnits } from "convert-units/definitions/length";
import { SpeedUnits } from "convert-units/definitions/speed";
import { isoToSeconds, toSeconds } from "../shared/duration";
import SensorBase from "./SensorBase";
import { ISensor } from "./Sensors";

const {
  compose,
  frozen,
  literal,
  map,
  maybe,
  model,
  number,
} = types;


export const toIntensity = (depth: number, interval: string): number =>
  depth * (toSeconds({ hours: 1 }) / isoToSeconds(interval));


const PrecipSensor = compose(
  SensorBase,
  model({
    type: literal("precip"),
    unit: frozen<LengthUnits>(),
    depths: map(maybe(number)),
  }))
    .views((self) => ({
      get totalUnit() {
        return self.unit;
      },
      totalFor(interval: string) {
        return self.depths.get(interval);
      },

      get intensityUnit() {
        return self.unit + "/h" as SpeedUnits;
      }

    }))
    .views((self) => ({
      intensityFor(interval: string) {
        const depth = self.totalFor(interval);
        if (depth === undefined) {
          return undefined;
        }
        return toIntensity(depth, interval);
      },
    }))
    .named("PrecipSensor");


export default PrecipSensor;

export const isPrecipSensor = (sensor: ISensor | undefined): sensor is IPrecipSensor => sensor?.type === "precip";
export interface IPrecipSensor extends Instance<typeof PrecipSensor> { }
export interface PrecipSensor_ extends SnapshotIn<typeof PrecipSensor> { }